export interface Movie {
  id: string;
  title: string;
  category: 'movie' | 'tv' | 'variety' | 'anime' | 'documentary';
  image: string;
  rating: number;
  year: number;
  director: string;
  actors: string;
  description: string;
  descriptionHtml: string;
  tags: string[];
  duration: string;
  region: string;
  updateInfo: string;
}

export const allMovies: Movie[] = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    category: 'movie',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20astronaut%20and%20giant%20planet%20in%20deep%20space%2C%20dramatic%20lighting%2C%20cinematic%20poster%20style%2C%20warm%20orange%20and%20deep%20blue%20contrast%2C%20epic%20scale%2C%20clean%20background&width=800&height=1120&seq=movie-1&orientation=portrait',
    rating: 8.5,
    year: 2024,
    director: '郭帆',
    actors: '吴京, 刘德华, 李雪健',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙旅程，年轻一代挺身而出，展开争分夺秒的生死之战。',
    descriptionHtml: '<p>太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙旅程，年轻一代挺身而出，展开争分夺秒的生死之战。本片延续前作宏大世界观，在视觉效果和情感深度上全面升级，呈现中国科幻电影的顶级水准。</p>',
    tags: ['科幻', '冒险', '灾难'],
    duration: '173分钟',
    region: '中国大陆',
    updateInfo: '2024年贺岁档',
  },
  {
    id: 'movie-2',
    title: '封神第二部',
    category: 'movie',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20mythology%20movie%20poster%20with%20ancient%20warriors%20and%20mythical%20creatures%2C%20epic%20battle%20scene%2C%20golden%20and%20crimson%20color%20scheme%2C%20cinematic%20style%2C%20dramatic%20composition&width=800&height=1120&seq=movie-2&orientation=portrait',
    rating: 8.8,
    year: 2024,
    director: '乌尔善',
    actors: '费翔, 黄渤, 于适',
    description: '殷商大军兵临西岐，姜子牙与姬发率领西岐军民奋起抵抗。一场决定天下归属的大战，在神话与历史的交织中拉开帷幕。',
    descriptionHtml: '<p>殷商大军兵临西岐，姜子牙与姬发率领西岐军民奋起抵抗。一场决定天下归属的大战，在神话与历史的交织中拉开帷幕。本作视觉效果震撼，将中国古典神话与现代电影技术完美融合。</p>',
    tags: ['奇幻', '古装', '神话'],
    duration: '148分钟',
    region: '中国大陆',
    updateInfo: '2024年暑期档',
  },
  {
    id: 'movie-3',
    title: '热辣滚烫',
    category: 'movie',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%20with%20boxing%20theme%2C%20warm%20lighting%2C%20inspirational%20sports%20atmosphere%2C%20bright%20and%20energetic%20colors%2C%20cinematic%20poster&width=800&height=1120&seq=movie-3&orientation=portrait',
    rating: 7.9,
    year: 2024,
    director: '贾玲',
    actors: '贾玲, 雷佳音, 张小斐',
    description: '宅家多年的乐莹，在结识拳击教练昊坤后，克服重重困难开启了滚烫的人生。这是一个关于勇气、改变和寻找自我的温暖故事。',
    descriptionHtml: '<p>宅家多年的乐莹，在结识拳击教练昊坤后，克服重重困难开启了滚烫的人生。这是一个关于勇气、改变和寻找自我的温暖故事，笑中带泪，传递满满正能量。</p>',
    tags: ['喜剧', '运动', '励志'],
    duration: '129分钟',
    region: '中国大陆',
    updateInfo: '2024年春节档',
  },
  {
    id: 'movie-4',
    title: '第二十条',
    category: 'movie',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20legal%20drama%20movie%20poster%20with%20courtroom%20atmosphere%2C%20serious%20tone%2C%20scales%20of%20justice%20motif%2C%20cinematic%20lighting%2C%20deep%20and%20contemplative%20mood&width=800&height=1120&seq=movie-4&orientation=portrait',
    rating: 8.3,
    year: 2024,
    director: '张艺谋',
    actors: '雷佳音, 马丽, 赵丽颖',
    description: '围绕刑法第二十条正当防卫条款，讲述检察官韩明在情与法的漩涡中坚守正义的故事。每一个案件背后，都是鲜活的人生。',
    descriptionHtml: '<p>围绕刑法第二十条正当防卫条款，讲述检察官韩明在情与法的漩涡中坚守正义的故事。每一个案件背后，都是鲜活的人生。张艺谋导演用现实主义笔触，探讨法与情的边界。</p>',
    tags: ['剧情', '法律', '现实主义'],
    duration: '141分钟',
    region: '中国大陆',
    updateInfo: '2024年春节档',
  },
  {
    id: 'movie-5',
    title: '飞驰人生2',
    category: 'movie',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20movie%20poster%20with%20sports%20cars%20on%20desert%20track%2C%20action%20and%20speed%2C%20warm%20sunset%20lighting%2C%20cinematic%20excitement%2C%20dynamic%20composition&width=800&height=1120&seq=movie-5&orientation=portrait',
    rating: 7.8,
    year: 2024,
    director: '韩寒',
    actors: '沈腾, 尹正, 范丞丞',
    description: '曾经的冠军车手张驰沦为落魄驾校教练，机缘巧合下重组车队，再次踏上巴音布鲁克拉力赛的征程，笑料与热血齐飞。',
    descriptionHtml: '<p>曾经的冠军车手张驰沦为落魄驾校教练，机缘巧合下重组车队，再次踏上巴音布鲁克拉力赛的征程，笑料与热血齐飞，延续第一部的速度与激情。</p>',
    tags: ['喜剧', '运动', '赛车'],
    duration: '124分钟',
    region: '中国大陆',
    updateInfo: '2024年春节档',
  },
  {
    id: 'movie-6',
    title: '熊出没·逆转时空',
    category: 'movie',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20family%20movie%20poster%20with%20cute%20bears%20and%20time%20travel%20theme%2C%20colorful%20and%20playful%2C%20bright%20animation%20style%2C%20whimsical%20adventure%20atmosphere&width=800&height=1120&seq=movie-6&orientation=portrait',
    rating: 7.6,
    year: 2024,
    director: '林汇达',
    actors: '谭笑, 张秉君, 张伟',
    description: '光头强和熊大熊二意外启动时空装置，穿越到不同时代展开奇妙冒险。在欢笑中感受亲情与友情的珍贵，适合全家观看。',
    descriptionHtml: '<p>光头强和熊大熊二意外启动时空装置，穿越到不同时代展开奇妙冒险。在欢笑中感受亲情与友情的珍贵，适合全家观看的合家欢动画电影。</p>',
    tags: ['动画', '喜剧', '冒险', '家庭'],
    duration: '96分钟',
    region: '中国大陆',
    updateInfo: '2024年春节档',
  },
  {
    id: 'tv-1',
    title: '庆余年第二季',
    category: 'tv',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%20with%20ancient%20palace%20and%20intrigue%2C%20rich%20costume%20design%2C%20golden%20and%20dark%20tone%2C%20mysterious%20atmosphere%2C%20cinematic%20quality&width=800&height=1120&seq=tv-1&orientation=portrait',
    rating: 8.9,
    year: 2024,
    director: '孙皓',
    actors: '张若昀, 李沁, 陈道明',
    description: '范闲假死后重返京都，面对更加复杂的朝堂局势和势力角逐，步步为营揭开身世之谜，在权谋与江湖间走出一条属于自己的路。',
    descriptionHtml: '<p>范闲假死后重返京都，面对更加复杂的朝堂局势和势力角逐，步步为营揭开身世之谜，在权谋与江湖间走出一条属于自己的路。第二季剧情更加紧凑，人物关系更加错综复杂。</p>',
    tags: ['古装', '权谋', '玄幻'],
    duration: '36集',
    region: '中国大陆',
    updateInfo: '已完结',
  },
  {
    id: 'tv-2',
    title: '繁花',
    category: 'tv',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20set%20in%201990s%20Shanghai%2C%20neon%20lights%2C%20vintage%20aesthetic%2C%20nostalgic%20atmosphere%2C%20golden%20warm%20tones%2C%20cinematic%20quality&width=800&height=1120&seq=tv-2&orientation=portrait',
    rating: 9.2,
    year: 2023,
    director: '王家卫',
    actors: '胡歌, 马伊琍, 唐嫣',
    description: '九十年代的上海，阿宝凭借敏锐的商业嗅觉和灵活的手段，在资本市场和外贸领域大展拳脚，演绎了一出荡气回肠的上海传奇。',
    descriptionHtml: '<p>九十年代的上海，阿宝凭借敏锐的商业嗅觉和灵活的手段，在资本市场和外贸领域大展拳脚，演绎了一出荡气回肠的上海传奇。王家卫首次执导电视剧，画面唯美，极具艺术质感。</p>',
    tags: ['剧情', '年代', '商战'],
    duration: '30集',
    region: '中国大陆',
    updateInfo: '已完结',
  },
  {
    id: 'tv-3',
    title: '与凤行',
    category: 'tv',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20romance%20drama%20poster%20with%20ethereal%20immortal%20beings%2C%20flowing%20robes%2C%20celestial%20palace%2C%20dreamy%20pastel%20colors%2C%20fantasy%20romance&width=800&height=1120&seq=tv-3&orientation=portrait',
    rating: 8.2,
    year: 2024,
    director: '邓科',
    actors: '赵丽颖, 林更新',
    description: '灵界碧苍王沈璃逃婚受伤坠落凡间，与上古神君行止相遇，两人在历经磨难中相知相爱，演绎一段跨越三界的旷世虐恋。',
    descriptionHtml: '<p>灵界碧苍王沈璃逃婚受伤坠落凡间，与上古神君行止相遇，两人在历经磨难中相知相爱，演绎一段跨越三界的旷世虐恋。仙侠美学新标杆。</p>',
    tags: ['仙侠', '爱情', '古装'],
    duration: '39集',
    region: '中国大陆',
    updateInfo: '已完结',
  },
  {
    id: 'tv-4',
    title: '猎冰',
    category: 'tv',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20poster%20with%20police%20and%20criminal%20confrontation%2C%20dark%20noir%20style%2C%20tense%20atmosphere%2C%20strong%20contrast%20lighting%2C%20gritty%20realism&width=800&height=1120&seq=tv-4&orientation=portrait',
    rating: 7.5,
    year: 2024,
    director: '高群书',
    actors: '张颂文, 姚安娜',
    description: '缉毒警察与制毒团伙展开惊心动魄的较量，在正邪对抗中揭示人性的复杂。紧张刺激的警匪对决，扣人心弦的悬疑剧情。',
    descriptionHtml: '<p>缉毒警察与制毒团伙展开惊心动魄的较量，在正邪对抗中揭示人性的复杂。紧张刺激的警匪对决，扣人心弦的悬疑剧情，展现缉毒一线真实而残酷的斗争。</p>',
    tags: ['悬疑', '犯罪', '警匪'],
    duration: '16集',
    region: '中国大陆',
    updateInfo: '已完结',
  },
  {
    id: 'variety-1',
    title: '奔跑吧·生态篇',
    category: 'variety',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20celebrities%20in%20outdoor%20adventure%2C%20bright%20sunny%20day%2C%20energetic%20and%20fun%20atmosphere%2C%20colorful%20and%20playful%20design&width=800&height=1120&seq=variety-1&orientation=portrait',
    rating: 7.8,
    year: 2024,
    director: '姚译添',
    actors: '李晨, 郑恺, 沙溢, 白鹿, 周深',
    description: '跑男团踏上生态环保之旅，走进大自然，在趣味游戏中传递绿色生活理念。欢笑与感动并存，展现人与自然的和谐之美。',
    descriptionHtml: '<p>跑男团踏上生态环保之旅，走进大自然，在趣味游戏中传递绿色生活理念。欢笑与感动并存，展现人与自然的和谐之美，寓教于乐的户外真人秀。</p>',
    tags: ['真人秀', '户外', '搞笑'],
    duration: '12期',
    region: '中国大陆',
    updateInfo: '热播中',
  },
  {
    id: 'variety-2',
    title: '歌手2024',
    category: 'variety',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20music%20competition%20show%20poster%20with%20spotlight%20stage%20and%20microphone%2C%20grand%20concert%20atmosphere%2C%20dramatic%20lighting%2C%20golden%20and%20dark%20contrast%2C%20premium%20quality&width=800&height=1120&seq=variety-2&orientation=portrait',
    rating: 8.6,
    year: 2024,
    director: '洪啸',
    actors: '那英, 汪苏泷, 杨丞琳',
    description: '华语乐坛顶级歌手同台竞技，用最纯粹的歌声打动人心。没有花哨的包装，只有最真实的live演唱，回归音乐本质。',
    descriptionHtml: '<p>华语乐坛顶级歌手同台竞技，用最纯粹的歌声打动人心。没有花哨的包装，只有最真实的live演唱，回归音乐本质，呈现最高水准的音乐盛宴。</p>',
    tags: ['音乐', '竞技', 'Live'],
    duration: '13期',
    region: '中国大陆',
    updateInfo: '热播中',
  },
  {
    id: 'anime-1',
    title: '斗破苍穹·年番',
    category: 'anime',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20animation%20poster%20with%20martial%20arts%20fantasy%20character%2C%20flaming%20energy%20effects%2C%20epic%20battle%20pose%2C%20dynamic%20action%2C%20rich%20colors%2C%20game-like%20art%20style&width=800&height=1120&seq=anime-1&orientation=portrait',
    rating: 8.4,
    year: 2024,
    director: '赵丙乐',
    actors: '张沛, 赵毅',
    description: '萧炎踏上中州大陆，面对更加强大的对手和势力，在不断的战斗中突破自我，向着斗气大陆的巅峰迈进。热血与成长并存的传奇冒险。',
    descriptionHtml: '<p>萧炎踏上中州大陆，面对更加强大的对手和势力，在不断的战斗中突破自我，向着斗气大陆的巅峰迈进。热血与成长并存的传奇冒险，顶级3D国漫制作。</p>',
    tags: ['热血', '玄幻', '战斗'],
    duration: '52集',
    region: '中国大陆',
    updateInfo: '连载中',
  },
  {
    id: 'anime-2',
    title: '凡人修仙传·星海飞驰',
    category: 'anime',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20donghua%20poster%20with%20immortal%20cultivator%20in%20starry%20sky%2C%20mystical%20energy%2C%20ancient%20Chinese%20aesthetic%2C%20misty%20mountains%2C%20cinematic%20animation%20quality&width=800&height=1120&seq=anime-2&orientation=portrait',
    rating: 8.9,
    year: 2024,
    director: '王裕仁',
    actors: '钱文青, 赵路',
    description: '韩立进入星海，在修仙之路上步步为营。以凡人之躯，行逆天之事，凭借智谋与毅力在残酷的修仙世界中寻找属于自己的一线生机。',
    descriptionHtml: '<p>韩立进入星海，在修仙之路上步步为营。以凡人之躯，行逆天之事，凭借智谋与毅力在残酷的修仙世界中寻找属于自己的一线生机。被誉为国漫巅峰之作。</p>',
    tags: ['修仙', '冒险', '智斗'],
    duration: '76集',
    region: '中国大陆',
    updateInfo: '连载中',
  },
  {
    id: 'doc-1',
    title: '航拍中国·第五季',
    category: 'documentary',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20aerial%20documentary%20poster%20with%20stunning%20landscape%20from%20above%2C%20mountains%20and%20rivers%2C%20golden%20hour%20lighting%2C%20breathtaking%20natural%20scenery%2C%20national%20geographic%20style&width=800&height=1120&seq=doc-1&orientation=portrait',
    rating: 9.4,
    year: 2024,
    director: '余乐',
    actors: '李立宏（解说）',
    description: '以空中视角俯瞰中国，展现神州大地的壮美风光和人文景观。用震撼的航拍镜头讲述中国故事，每一帧都是壁纸级的美景。',
    descriptionHtml: '<p>以空中视角俯瞰中国，展现神州大地的壮美风光和人文景观。用震撼的航拍镜头讲述中国故事，每一帧都是壁纸级的美景，带你领略祖国的辽阔与壮美。</p>',
    tags: ['自然', '地理', '人文'],
    duration: '10集',
    region: '中国大陆',
    updateInfo: '已完结',
  },
  {
    id: 'doc-2',
    title: '舌尖上的中国·第四季',
    category: 'documentary',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20with%20delicious%20traditional%20cuisine%2C%20steaming%20dishes%2C%20warm%20kitchen%20lighting%2C%20rich%20food%20photography%2C%20appetizing%20colors&width=800&height=1120&seq=doc-2&orientation=portrait',
    rating: 9.1,
    year: 2024,
    director: '陈晓卿',
    actors: '李立宏（解说）',
    description: '深入中国各地的厨房和田野，探寻美食背后的文化与情感。从食材到餐桌，每一道菜都是一个故事，每一口都是家的味道。',
    descriptionHtml: '<p>深入中国各地的厨房和田野，探寻美食背后的文化与情感。从食材到餐桌，每一道菜都是一个故事，每一口都是家的味道，最美的中国美食纪录片。</p>',
    tags: ['美食', '文化', '人文'],
    duration: '8集',
    region: '中国大陆',
    updateInfo: '已完结',
  },
];

export const categoryMap: Record<string, string> = {
  movie: '电影',
  tv: '电视剧',
  variety: '综艺',
  anime: '动漫',
  documentary: '纪录片',
};

export const categorySlugs: Record<string, string> = {
  movie: 'dianying',
  tv: 'dianshiju',
  variety: 'zongyi',
  anime: 'dongman',
  documentary: 'jilupian',
};

export const slugToCategory: Record<string, string> = {
  dianying: 'movie',
  dianshiju: 'tv',
  zongyi: 'variety',
  dongman: 'anime',
  jilupian: 'documentary',
};